export interface VisibleFilterType {
  visibility: server.dto.VisibleFilterSettings
}

export const initialVisibleFilter: VisibleFilterType = {
  visibility: "noFilter"
};